import * as views from './views'

export const Views = {...views}
